/*
* Si posono modificare tramite props
*   background
*   titleSize
*   titleText
*   subTitleSize
*   subTitleText
*/

import React, { Component } from "react";
import RaisedButton from "material-ui/RaisedButton";
import createBrowserHistory from "history/createBrowserHistory";
import * as PAGESSWITCH from "../Utils/PagesSwitch.js";
import * as ROUTE       from "../Utils/Strings/Route";
let history = createBrowserHistory();


class GoToLogin extends Component {
  constructor(props) {
    super(props);
  }

  handleOnClick = () => {
    PAGESSWITCH.gotoPageWithParams(ROUTE.Root)
  }

  render() {
    
    const styles = {
        container : {
          background     : this.props.background || "#2f6cc2",
          position       : "absolute",
          width          : "100%",
          height         : "100%",
          zIndex         : "16777271",
          display        : "flex",
          justifyContent : "center",
          alignItems     : "center",
        },
        title : {
          fontSize  : this.props.titleSize || "4em",
          textAlign : "center",
          margin    : "25px"
        },
        subTitle : {
          fontSize : this.props.subTitleSize || "2em",
          margin    : "25px"
        },
        list: {
          listStyle : "none",
          paddingLeft : "0px"
        },
        button : {
          display        : "flex",
          justifyContent : "center",
          alignItems     : "center",
          width          : "50%",
          marginLeft     : "25%",
          marginTop      : "50px"
        }

    }

    return (
        this.props.isAuthenticated == false &&
        <div style={styles.container}>
          <ul style={styles.list}>
            <li>
              <div style={styles.title}> {this.props.titleText || "Ops!"} </div>
            </li>
            <li>
              <div style={styles.subTitle}> {this.props.subTitleText || "Impossibile visualizzare il contenuto della pagina. Effettuare il login per poter accedere alla pagina richiesta."} </div>
            </li>
            <li>
              <div style={styles.button}>
                <RaisedButton
                  label="Vai al Login"
                  primary={true}
                  onClick={this.props.onClick || this.handleOnClick}
                  fullWidth={true}
                />
              </div>
            </li>
          </ul>          
        </div>
    );
  }
}

export default GoToLogin;



// WEBPACK FOOTER //
// ./src/Components/component_GoToLogin.js